import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export function SettingsModal({ open, onOpenChange }) {
  const { user, updateProfile, changePassword } = useAuth();
  const [displayName, setDisplayName] = useState(user?.display_name || "");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const handleNameSave = async () => {
    const res = await updateProfile(displayName);
    if (res.success) toast.success("Display name updated");
    else toast.error(res.error);
  };

  const handlePasswordSave = async () => {
    const res = await changePassword(oldPassword, newPassword);
    if (res.success) {
      toast.success("Password updated successfully");
      setOldPassword("");
      setNewPassword("");
    } else toast.error(res.error);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-igc-surface border-igc-gold/20 text-igc-cream max-w-md max-h-[85vh] overflow-y-auto" data-testid="settings-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-igc-cream">Account Settings</DialogTitle>
        </DialogHeader>
        <div className="space-y-6 pt-2">
          {user?.role === "client" && (
            <div>
              <label className="text-xs uppercase tracking-widest text-igc-muted mb-2 block">Display Name</label>
              <div className="flex gap-2">
                <Input data-testid="settings-display-name-input" value={displayName} onChange={(e) => setDisplayName(e.target.value)} title="The name shown to your team on the portal." className="bg-igc-surfaceLight border-igc-gold/20" />
                <Button data-testid="settings-save-name-button" onClick={handleNameSave} title="Saves your new display name." className="bg-igc-gold hover:bg-igc-goldHover text-black">Save</Button>
              </div>
            </div>
          )}
          <div>
            <label className="text-xs uppercase tracking-widest text-igc-muted mb-2 block">Change Password</label>
            <div className="space-y-2">
              <Input data-testid="settings-old-password-input" type="password" placeholder="Current password" title="Your current password, to confirm it's really you." value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} className="bg-igc-surfaceLight border-igc-gold/20" />
              <Input data-testid="settings-new-password-input" type="password" placeholder="New password" title="The new password you want to use going forward." value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="bg-igc-surfaceLight border-igc-gold/20" />
              <Button data-testid="settings-save-password-button" onClick={handlePasswordSave} title="Updates your login password." className="w-full bg-igc-gold hover:bg-igc-goldHover text-black">Update Password</Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
